import React from 'react';

import { useQueryClient } from 'react-query';

import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';

import { useVersionStore } from 'store/version.store';

import { useMutationChangeAssignee } from 'api/mutations/changeAssignee.mutation';

import { AssigneeAvatarWithSelection } from 'components/common/AssigneeAvatarWithSelection/AssigneeAvatarWithSelection';

import { IAssignee } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';

import classes from './AssigneeCell.module.scss';

interface Props {
    assignee: IAssignee | null;
    taskId: string | number;
    isVirtual: boolean;
    invalidateQueriesKey: string[];
    isAssigneeDisabled?: boolean;
}

export const AssigneeCell = ({
    assignee,
    taskId,
    isVirtual,
    invalidateQueriesKey,
    isAssigneeDisabled = false,
}: Props) => {
    const { handleSnackBar } = useCustomSnackBar();
    const queryClient = useQueryClient();
    const currentVersion = useVersionStore((state) => state.version);
    const { mutate } = useMutationChangeAssignee();

    const handleAssigneeSelection = (value) => {
        if (currentVersion) {
            mutate(
                {
                    cardId: taskId,
                    isVirtual: isVirtual,
                    username: value,
                    versionId: currentVersion.id,
                },
                {
                    onSuccess: () => {
                        handleSnackBar('Assignee Successfully Changed', 'success');
                        return Promise.all(invalidateQueriesKey.map((key) => queryClient.invalidateQueries(key)));
                    },
                    onError: (error) => {
                        DEFAULT_ERROR({ error, handleError: handleSnackBar });
                    },
                },
            );
        }
    };

    return (
        <div className={classes.AssigneeCell}>
            <AssigneeAvatarWithSelection
                assignee={assignee}
                handleSelection={handleAssigneeSelection}
                isDisabled={isAssigneeDisabled}
            />
        </div>
    );
};
